<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value="date"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formated_data"
        @input="$emit('change', $event)"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="{ ...attrs, ...$attrs }"
        v-on="on"
        :error-messages="error_messages"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="date"
      @input="$emit('change', $event)"
      no-title
      scrollable
      v-bind="$attrs"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import { formatDate } from "@/tools/date";

export default {
  name: "date-picker",
  props: {
    date: {
      default: "",
      type: String,
    },
    error_messages: {
      default: () => [],
      type: Array,
    },
  },
  model: {
    prop: "date",
    event: "change",
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    formated_data: function () {
      return formatDate(this.date);
    },
  },
};
</script>